import { Injectable } from '@angular/core';

@Injectable()
export class EnvServices {
    constructor () {}

    public getEnvironment(): string {
        const envCd = global['envCd'];
        let envName = '';
        switch (envCd) {
            case 'chn':
            case 'prdecs':
            case 'prdeks':
            case 'prd':
            case 'sec-prod':
                envName = 'PROD';
                break;
            case 'loc':
                envName = 'Local';
                break;
            case 'devecs':
            case 'deveks':
            case 'dev':
                envName = 'DEV';
                break;
        }
        return envName;
    }

    public getServiceLocale(): string {
        return !!location.host.match(new RegExp('.cn')) ? 'China' : 'Global';
    }

    public isWhiteLabeled(): boolean {
        return !location.host.match(new RegExp('opsnow.com'));
    }

    public isSecAlertNow(): boolean {
        return !!location.host.match(new RegExp('sec-alertnow.com'));
    }

    // public getZendeskUseFlag(): boolean {
    //     return false; /*this.getEnvironment() === 'PROD' && this.getServiceLocale() === 'Global' && !this.isWhiteLabeled()*/
    // }

    public getArchitecture() {
        const envCd = global['envCd'];
        let architecture = '';
        switch (envCd) {
            case 'chn':
            case 'sec-prod':
                architecture = 'anakin';
                break;
            default:
                architecture = 'luke';
                break;
        }
        return architecture;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/env.services.ts